module.exports = __webpack_public_path__ + "img/Slide_Principal_Escut.df455204.jpg";